import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CountyHomeCare {
  id: string;
  county_slug: string;
  county_name: string;
  overview: string | null;
  hse_services: string | null;
  private_providers: string | null;
  home_care_packages: string | null;
  cost_info: string | null;
  key_contacts: string | null;
  enrichment_status: string;
  updated_at: string;
}

export function useCountyHomeCare(countySlug: string | undefined) {
  return useQuery({
    queryKey: ['county-home-care', countySlug],
    queryFn: async () => {
      if (!countySlug) return null;

      const { data, error } = await supabase
        .from('county_home_care')
        .select('*')
        .eq('county_slug', countySlug)
        .eq('enrichment_status', 'complete')
        .maybeSingle();

      if (error) throw error;
      return data as CountyHomeCare | null;
    },
    enabled: !!countySlug,
  });
}
